const areas = {
  apiPath: 'areas/',
  buttonNew: 'Стварыць сферу',
  tableConfig: {
    name: {
      key: 'name',
      title: 'Назва',
      sortable: true,
    },
    updatedAt: {
      key: 'updatedAt',
      title: 'Абноўлена',
      sortable: true,
      format: 'date',
    },
    status: {
      key: 'status',
      title: 'Статус',
      sortable: true,
    },
  },
};

export default areas;
